import e from "./text-output-callback.js";
class a extends e {
  /**
   * @param payload The raw payload returned by OpenAM
   */
  constructor(t) {
    super(t), this.payload = t;
  }
}
export {
  a as default
};
